import React, { Component } from 'react';
import i18n from '../../i18next';
import { Row, Col } from 'reactstrap';

import RestaurantUtils from '../../utils/RestaurantUtils';
import { convertSecToMin, localizeStatuses, localizeActions } from '../../utils/CommonUtils';
import { OFFLINE, ONLINE, SUCCESS } from '../../utils/Constants';

class MainJobDetails extends Component {
    render() {
        const jobStatusChange = (this.props.selectedJob.status === SUCCESS) ? ONLINE : OFFLINE;
        const jobStatusColor = RestaurantUtils.getPosStatusColor(jobStatusChange);
        const statusColor = { color: jobStatusColor };
        const isHidden = (this.props.selectedJob.userName.length == 0) ? true : false;

        return (
            <div>
                <Row>
                    <Col xs={12} sm={6}>
                        <p>{i18n.t('screens:mainJobDetails.id')}: <span>{this.props.selectedJob.id}</span></p>
                    </Col>
                    <Col xs={12} sm={6}>
                        <p>{i18n.t('screens:jobsHistoryScreen.restaurant')}: <span>{this.props.selectedJob.restaurantName}</span></p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6}>
                        <p>{i18n.t('screens:jobsHistoryScreen.action')}: <span>{localizeActions(this.props.selectedJob.action)}</span></p>
                    </Col>
                    <Col xs={12} sm={6}>
                        <p>{i18n.t('screens:orderHistoryScreen.status')}: <span style={statusColor}>{localizeStatuses(this.props.selectedJob.status)}</span></p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6}>
                        <p>{i18n.t('screens:jobsHistoryScreen.scheduledAt')}: <span>{this.props.selectedJob.scheduledAt}</span></p>
                    </Col>
                    <Col xs={12} sm={6}>
                        <p>{i18n.t('screens:jobsHistoryScreen.startedAt')}: <span>{this.props.selectedJob.startedAt}</span></p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6} hidden={isHidden}>
                        <p>{i18n.t('screens:jobsHistoryScreen.user')}: <span>{this.props.selectedJob.userName}</span></p>
                    </Col>
                    <Col xs={12} sm={6}>
                        <p>{i18n.t('screens:jobsHistoryScreen.duration')}: <span>{convertSecToMin(this.props.selectedJob.duration)}</span></p>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default MainJobDetails;


// WEBPACK FOOTER //
// ./src/components/jobhistory/MainJobDetails.js